import React, { FC } from 'react';

import classNames from 'classnames';

import { EvSection, EvSpinner, EvTitle } from '@evinced-private/ui-common';

import {
	MFA_DASHBOARD_PAGE_SUMMARY_SECTION_ID,
	MFA_DASHBOARD_PAGE_SUMMARY_TITLE_ID
} from 'data-automation-ids/MfaDashboardAutomationIds';
import { SummaryPane } from 'src/common/components/summary-pane/SummaryPane';
import { SummaryItem } from 'src/common/interfaces/SummaryItem';

import './MfaSessionsSummary.scss';

interface IMfaDashboardUsageSectionProps {
	data: SummaryItem[];
	isLoading: boolean;
	selectedPeriodLabel?: string;
}

const getUsageDataTooltipText = (selectedPeriodLabel: string): string =>
	`Usage within the ${selectedPeriodLabel.toLowerCase()} compared to the previous period (if applicable).`;

export const MfaSessionsSummary: FC<IMfaDashboardUsageSectionProps> = ({
	data,
	isLoading,
	selectedPeriodLabel = 'All Sessions'
}) => {
	return (
		<EvSection
			ariaLabel="Last month usage"
			skipLinkId="usage-section"
			className={classNames('dashboard-section', 'mfa-sessions-summary')}
			ariaLive="polite"
			dataAutomationId={MFA_DASHBOARD_PAGE_SUMMARY_SECTION_ID}
		>
			<EvTitle
				titleText="Summary"
				headingLevel={2}
				className="page-heading"
				dataAutomationId={MFA_DASHBOARD_PAGE_SUMMARY_TITLE_ID}
				MoreInfoContent={<>{getUsageDataTooltipText(selectedPeriodLabel)}</>}
			/>
			{isLoading ? (
				<EvSpinner />
			) : (
				<SummaryPane
					items={data}
					shouldHaveSkipLink={false}
					className="base-summary-pane"
					ariaLabel="Last month usage summary"
				/>
			)}
		</EvSection>
	);
};
